<sb-card [halfHeight]="true" [loadingDelay]="1" [loading]="loading">
  <div card-header>
    <h1>{{ 'lang.dashboard.playoutsPerPublisher' | translate }}</h1>
    <small>{{ 'lang.dashboard.pastCountDays' | translate: {count: 7} }}</small>
  </div>
  <div card-header-more>
    <div class="font-weight-normal text-right" style="font-size: 12px" #chartLegend></div>
  </div>
  <sb-chart chartType="pieChart" #chart card-body
            [chartData]="playoutChart"></sb-chart>
</sb-card>
